import React from 'react';
import { FormattedMessage } from 'react-intl';
import ToastWrapper from '@/components/toasts/ToastWrapper';
import { userSearchableIcon } from '../constants';

const UserSearchableToast = ({ item }) => {
  const { name, searchable } = item;

  return (
    <ToastWrapper
      className="aridhia-user-searchable-toast"
      icon={userSearchableIcon(!searchable)}
      color={searchable ? 'green' : 'red'}
    >
      <FormattedMessage id={searchable ? 'toast.searchable' : 'toast.searchable.not'} values={{ name }} />
    </ToastWrapper>
  );
};

export default UserSearchableToast;
